// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.graph-buttons-container {
    padding: 10px 0 20px;
}

.graph-button {
    background-color: transparent;
    padding: 10px 20px;
    cursor: pointer;
    border: none;
    font-weight: bold;
    transition: border-color 0.3s ease, color 0.3s ease;
    font-size: 16px;
    color: #2E75B7;
}

.graph-button:disabled,
.graph-button.active {
    border-bottom: 4px solid #2E75B7;
    cursor: pointer;
}

.graph-button:hover {
    color: #2e75b7ab;
}

.separator {
    margin: 0 10px;
    color: #ccc;
    font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/componentsCSS/GraphButtons.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,mDAAmD;IACnD,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,iBAAiB;AACrB","sourcesContent":[".graph-buttons-container {\n    padding: 10px 0 20px;\n}\n\n.graph-button {\n    background-color: transparent;\n    padding: 10px 20px;\n    cursor: pointer;\n    border: none;\n    font-weight: bold;\n    transition: border-color 0.3s ease, color 0.3s ease;\n    font-size: 16px;\n    color: #2E75B7;\n}\n\n.graph-button:disabled,\n.graph-button.active {\n    border-bottom: 4px solid #2E75B7;\n    cursor: pointer;\n}\n\n.graph-button:hover {\n    color: #2e75b7ab;\n}\n\n.separator {\n    margin: 0 10px;\n    color: #ccc;\n    font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
